import { useEffect, useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";

import {
  ColorCircle,
  ColorPickerButton,
  ColorRow,
  SectionTitle,
  Wrapper,
  PickerPopover,
} from "./QrCustomizerStyles";

import { QrCustomizerProps } from "../../../types/componentsConstructors";

import wallpaper1 from "../../../img/logged/wallpaper/wallpaperPresskit.png";
import wallpaper2 from "../../../img/logged/wallpaper/wallpaperOnOff.png";
import wallpaper3 from "../../../img/logged/wallpaper/wallpaperOnOffBlack.png";
import wallpaper4 from "../../../img/logged/wallpaper/wallpaper.png";
import wallpaper5 from "../../../img/logged/wallpaper/wallpaperPresskitTexture.png";
import Brush from "../../../img/logged/brush.png";
import WallpaperCarousel from "../../wallpaperCarousel/WallpaperCarousel";

const QrCustomizer = ({
  primaryColor,
  backgroundColor,
  borderColor,
  wallpaperUrl,
  onPrimaryColorChange,
  onBackgroundColorChange,
  onBorderColorChange,
  onWallpaperSelect,
}: QrCustomizerProps) => {
  const borderColors = ["#A000C5", "#D41490", "#2A75E5", "#00D9FF"];
  const primaryColors = ["#FF01A2", "#00AAFF", "#A400FF", "#FFFFFF"];
  const backgroundColors = ["#000000", "#010917", "#020268ff", "#240141ff"];

  const [openPrimary, setOpenPrimary] = useState(false);
  const [openBorder, setOpenBorder] = useState(false);
  const [openBg, setOpenBg] = useState(false);

  const refPrimary = useRef<HTMLDivElement>(null);
  const refBorder = useRef<HTMLDivElement>(null);
  const refBg = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (refPrimary.current && !refPrimary.current.contains(e.target as Node))
        setOpenPrimary(false);
      if (refBorder.current && !refBorder.current.contains(e.target as Node))
        setOpenBorder(false);
      if (refBg.current && !refBg.current.contains(e.target as Node))
        setOpenBg(false);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <Wrapper>
      <SectionTitle>Cor do QR Code</SectionTitle>
      <ColorRow ref={refPrimary}>
        <ColorPickerButton
          $current={primaryColor}
          title="Selecionar cor personalizada"
          onClick={() => setOpenPrimary((v) => !v)}
        >
          <img src={Brush} alt="Selecionar cor do QR" />
        </ColorPickerButton>

        {primaryColors.map((color) => (
          <ColorCircle
            key={color}
            $active={color === primaryColor}
            style={{ backgroundColor: color }}
            onClick={() => {
              onPrimaryColorChange(color);
              setOpenPrimary(false);
            }}
          />
        ))}

        {openPrimary && (
          <PickerPopover>
            <HexColorPicker
              color={primaryColor}
              onChange={onPrimaryColorChange}
            />
          </PickerPopover>
        )}
      </ColorRow>

      <SectionTitle>Cor da Borda</SectionTitle>
      <ColorRow ref={refBorder}>
        <ColorPickerButton
          $current={borderColor}
          title="Selecionar cor personalizada"
          onClick={() => setOpenBorder((v) => !v)}
        >
          <img src={Brush} alt="Selecionar cor da borda" />
        </ColorPickerButton>

        {borderColors.map((color) => (
          <ColorCircle
            key={color}
            $active={color === borderColor}
            style={{ backgroundColor: color }}
            onClick={() => {
              onBorderColorChange(color);
              setOpenBorder(false);
            }}
          />
        ))}

        {openBorder && (
          <PickerPopover>
            <HexColorPicker
              color={borderColor}
              onChange={onBorderColorChange}
            />
          </PickerPopover>
        )}
      </ColorRow>

      <SectionTitle>Cor de Fundo QR Code</SectionTitle>
      <ColorRow ref={refBg}>
        <ColorPickerButton
          $current={backgroundColor}
          title="Selecionar cor personalizada"
          onClick={() => setOpenBg((v) => !v)}
        >
          <img src={Brush} alt="Selecionar cor de fundo" />
        </ColorPickerButton>

        {backgroundColors.map((color) => (
          <ColorCircle
            key={color}
            $active={color === backgroundColor}
            style={{ backgroundColor: color }}
            onClick={() => {
              onBackgroundColorChange(color);
              setOpenBg(false);
            }}
          />
        ))}

        {openBg && (
          <PickerPopover>
            <HexColorPicker
              color={backgroundColor}
              onChange={onBackgroundColorChange}
            />
          </PickerPopover>
        )}
      </ColorRow>

      <SectionTitle>Wallpaper</SectionTitle>
      <WallpaperCarousel
        wallpapers={[
          wallpaper1,
          wallpaper2,
          wallpaper3,
          wallpaper4,
          wallpaper5,
        ]}
        selectedUrl={wallpaperUrl}
        onSelect={(url) => onWallpaperSelect(url)}
      />
    </Wrapper>
  );
};

export default QrCustomizer;
